import React, { useState, useEffect } from "react";
import SidebarEtd from '../../../shared/components/SidebarEtd';
import HeaderEtd from '../../../shared/components/HeaderEtd';
import { Button } from "react-bootstrap";
//import "./printOut/assets/bill.css";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { getLoginInfo } from '../../../shared/utils/storage';
import { basicApi } from '../../../shared/services/apiService';
import AppManagementReusComponent from '../../../shared/hooks/useApplicationManagement';
import { generatePDF } from "../../../shared/services/listReport.jsx";
import Lindo from '../../../app/guards/RouteGuard';
import loadingIcon from '../../../assets/img/loadingElement.gif';
import SharedTable from "../../administration/users/SearchUser.jsx";
import ReportTableComponent from "../components/ReportTable.jsx";
import { reportFormValidation } from '../../../shared/validators/FormValidator';
function DataReportsPayment() {
  const pageName = "report";
  const [pdfBase64, setPdfBase64] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [station, setStation] = useState(getLoginInfo()?.user?.Station);
  const rolesData = getLoginInfo()?.user?.Roles || [];
  let roleList = [];
  try {
    roleList = typeof rolesData === "string" ? JSON.parse(rolesData) : rolesData;
  } catch (error) {
    console.error("Error parsing roles:", error);
    roleList = [];
  }
  const hasRole = (roleCode) => {
    return Array.isArray(roleList) && roleList.some((role) => role?.RoleCode === roleCode);
  };

  hasRole("SUPER_ADMIN") || hasRole("ETD_administrator")

  const [application, setApplication] = useState([]);
  const { loading, handleApplicationManagement } = AppManagementReusComponent();
  const [newData, setNewData] = useState([]);
  const [searchapp, setSearchapp] = useState({
    UserName: getLoginInfo()?.user?.Username,
    TerritoryID:getLoginInfo()?.user?.territoryID,
    RegionID: "",
    Station:
      hasRole("SUPER_ADMIN") || hasRole("ETD_administrator")
        ? ""
        : getLoginInfo()?.user?.StationID,
    StartDate: "",
    EndDate: "",
    ReportType: "",
    DocTypeID: "",
  });
// searchapp?.ReportType !== "get_etd_reports_by_admin" ? getLoginInfo()?.user?.Username : "",
   const [adminSearchapp, setAdminSearchapp] = useState({
    UserName: getLoginInfo()?.user?.Username,
    TerritoryID: "",
    RegionID: "",
    Station: "",
    StartDate: "",
    EndDate: "",
    ReportType: "",
    DocTypeID: "",
  });
  const [errors, setErrors] = useState({});
  const [noDataMessage, setNoDataMessage] = useState("");
  const [territoryData, setTerritoryData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [stationData, setStationData] = useState([]);

  const { mgambo } = Lindo();
  useEffect(() => {
    let station = mgambo("Taarifa");
    fetchTerritories();
  }, []);

  const fetchTerritories = async () => {
    const payload = {
      ApplicationId: null,
      EmailAddress: getLoginInfo()?.user?.EmailAddress || "",
      ResourceParam: "NULL",
      ResourceParam2: "NULL",
      OperationType: "Territory",
    };
    try {
      const result = await basicApi(payload, "cnrs/lookup");
      if (result?.code == 1 && result.data) {
        setTerritoryData(result.data[0]?.payloadResult || []);
      }
    } catch (e) {
      console.error("Error fetching territories:", e);
    }
  };

  const getRegions = async (territoryId) => {
    const payload = {
      Argument1: String(territoryId),
      Argument2: "NULL",
      OperationType: "REGION",
    };
    try {
      const result = await basicApi(payload, "cnrs/lookup");
      if (result?.code == 1 && result.data) {
        setRegionData(result.data[0]?.payloadResult || []);
      }
    } catch (e) {
      console.error("Error fetching regions:", e);
    }
  };

  const getStations = async (regionId) => {
    const payload = {
      Argument1: String(regionId),
      Argument2: "NULL",
      OperationType: "STATION",
    };
    try {
      const result = await basicApi(payload, "cnrs/lookup");
      if (result?.code == 1 && result.data) {
        setStationData(result.data[0]?.payloadResult || []);
      }
    } catch (e) {
      console.error("Error fetching stations:", e);
    }
  };

  const territoryHandler = (e) => {
    setApplication([]);
    const newValue = e.target.value;
    setRegionData([]);
    setStationData([]);
    setSearchapp((prev) => ({
      ...prev,
      TerritoryID: newValue,
      RegionID: "",
      Station: "",
    }));
    getRegions(newValue);
  };

  const regionHandler = (e) => {
    setApplication([]);
    const newValue = e.target.value;
    setStationData([]);
    setSearchapp((prev) => ({
      ...prev,
      RegionID: newValue,
      Station: "",
    }));
    getStations(newValue);
  };

  const stationHandler = (e) => {
    setApplication([]);
    const newValue = e.target.value;
    setSearchapp((prev) => ({
      ...prev,
      Station: newValue,
    }));
  };
  const handleOption = (e) => {
    setApplication([]);
    const newValue = e.target.value;
    setSearchapp((prev) => ({
      ...prev,
      ReportType: newValue,
    }));
  };

  const documentHandler = (e) => {
    setApplication([]);
    const newValue = e.target.value;
    setSearchapp((prev) => ({
      ...prev,
      DocTypeID: newValue,
    }));
  };
  const searchData = async () => {
    setApplication([]);

    const newErrors = reportFormValidation(searchapp);
    if (Object?.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setIsSearching(true);
      setErrors({});
      setNoDataMessage("");
      try {
        const result = await handleApplicationManagement(
          searchapp,
          searchapp?.ReportType === "get_etd_reports_by_admin" ? "issued_etd_reports" : searchapp?.ReportType
        );
        setIsSearching(false);
        if (result?.code == 1 && result.data) {
          if (result.data?.PoolList?.length > 0) {
            setApplication(result.data);
          } else {
            setNoDataMessage(result?.message || "No data found.");
          }
        } else {
          setNoDataMessage(result?.message || "Failed to retrieve data.");
        }
      } catch (e) {
        setIsSearching(false);
        setNoDataMessage("An error occurred. Please try again.");
      }
    }
  };

    const adminSearchData = async () => {
    setApplication([]);

    const newErrors = reportFormValidation(adminSearchapp);
    if (Object?.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setIsSearching(true);
      setErrors({});
      setNoDataMessage("");
      try {
        const result = await handleApplicationManagement(
          adminSearchapp,adminSearchapp?.ReportType
        );
        setIsSearching(false);
        if (result?.code == 1 && result.data) {
          if (result.data?.PoolList?.length > 0) {
            setApplication(result.data);
          } else {
            setNoDataMessage(result?.message || "No data found.");
          }
        } else {
          setNoDataMessage(result?.message || "Failed to retrieve data.");
        }
      } catch (e) {
        setIsSearching(false);
        setNoDataMessage("An error occurred. Please try again.");
      }
    }
  };

  const clearFrom = () => {
    setPdfBase64(null);
  };

  const styles = {
    loadingContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    loadingImage: {
      width: "70px",
      height: "70px",
    },
    td: {
      textAlign: "center",
    },
  };

  return (
    <>
      <HeaderEtd />
      <body className="">
        <div className="wrapper">
          <SidebarEtd />
          <div className="main-panel">
            <div className="content4">
              <div className="card-body"></div>
              <div className="row2">
                <div className="col-md-12">
                  <div className="card2">
                    <div className="card-body">
                      <div className="row2">
                        <div className="col-md-4">
                          <Box component="form" sx={{ minWidth: 230 }}>
                            <FormControl fullWidth>
                              <InputLabel id="demo-simple-select-label">
                                Report Search
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="outlined-required"
                                label="Report Search"
                                onChange={(e) => handleOption(e)}
                              >
                                <MenuItem value="issued_etd_reports">
                                  ETD Issued Report
                                </MenuItem>
                                <MenuItem value="defined_reports">
                                  Defined Report
                                </MenuItem>
                                {/* <MenuItem value="rejected_etd_reports">
                                  ETD Rejected Report
                                </MenuItem> */}
                                <MenuItem value="payments_report">
                                  ETD Payment Report
                                </MenuItem>
                                {(station === "HQ" || station === "HO") && (
                                  <MenuItem value="online_issued_etd_report">
                                    ETD Online Issued Report
                                  </MenuItem>
                                )}
                                {(station === "HQ" || station === "HO") && (
                                  <MenuItem value="online_payments_report">
                                    ETD Online Payment Report
                                  </MenuItem>
                                )}
                                {/* <MenuItem value="PaymentsReport">
                                  ETD Application Report
                                </MenuItem> */}
                                {/* <MenuItem value="PaymentsReport">
                                  ETD Renew Report
                                </MenuItem> */}
                                
                                <MenuItem value="get_etd_reports_by_doctype">
                                  Report By Document
                                </MenuItem>
                                {(hasRole("SUPER_ADMIN") || hasRole("ETD_administrator")) && (
                                  <MenuItem value="get_etd_reports_by_admin">
                                    Admin Report
                                  </MenuItem>
                                )}
                              </Select>
                            </FormControl>
                          </Box>
                        </div>
                        {searchapp.ReportType ===
                          "get_etd_reports_by_doctype" && (
                          <div className="col-md-4">
                            <Box component="form" sx={{ minWidth: 230 }}>
                              <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                  Document Type
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="outlined-required"
                                  label="Report Search"
                                  onChange={(e) => documentHandler(e)}
                                  required
                                >
                                  {(station === "HQ" || station === "HO") && (
                                    <MenuItem value="1">passport</MenuItem>
                                  )}
                                  {(station === "HQ" || station === "HO") && (
                                    <MenuItem value="2">ETD</MenuItem>
                                  )}

                                  <MenuItem value="3">NIDA</MenuItem>
                                  <MenuItem value="4">
                                    Sponsored by passport
                                  </MenuItem>
                                  <MenuItem value="5">
                                    Sponsored by NIDA
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Box>
                          </div>
                        )}

  {searchapp.ReportType ===
                          "get_etd_reports_by_admin" && (
                            <>
                             <div className="col-md-4">
                            <Box component="form" sx={{ minWidth: 230 }}>
                              <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                  Select Territory
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="outlined-required"
                                  label="Select Territory"
                                  onChange={(e) => territoryHandler(e)}
                                  required
                                >
                                  {territoryData?.map((obj) => (
                                    <MenuItem key={obj.TerritoryID} value={obj.TerritoryID}>
                                      {obj.TerritoryName}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Box>
                          </div>

                           <div className="col-md-4">
                            <Box component="form" sx={{ minWidth: 230 }}>
                              <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                  Select Region
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="outlined-required"
                                  label="Select Region"
                                  onChange={(e) => regionHandler(e)}
                                  required
                                >
                                  {regionData?.map((obj) => (
                                    <MenuItem key={obj.EntryID} value={obj.EntryID}>
                                      {obj.RegionName}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Box>
                          </div>

                           <div className="col-md-4">
                            <Box component="form" sx={{ minWidth: 230 }}>
                              <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                  Select Station
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="outlined-required"
                                  label="Select Station"
                                  onChange={(e) => stationHandler(e)}
                                  required
                                >
                                  {stationData?.map((obj) => (
                                    <MenuItem key={obj.StationID} value={obj.StationID}>
                                      {obj.StationName}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Box>
                          </div>
                            </>                                                  
                        )}
                        <div className="col-md-4">
                          <Box component="form" sx={{ minWidth: 230 }}>
                            <FormControl fullWidth>
                              <TextField
                                id="outlined-required"
                                label="Start date"
                                type="date"
                                onChange={(e) => {
                                  searchapp.StartDate = e.target.value;
                                }}
                                focused
                              />
                            </FormControl>
                          </Box>
                        </div>
                        <div className="col-md-4">
                          <Box component="form" sx={{ minWidth: 230 }}>
                            <FormControl fullWidth>
                              <TextField
                                id="outlined-required"
                                label="End date"
                                type="date"
                                onChange={(e) => {
                                  searchapp.EndDate = e.target.value;
                                }}
                                focused
                              />
                            </FormControl>
                          </Box>
                        </div>

                        <div className="col-md-4"></div>
                        <div className="col-md-4">
                        <Button
                            variant="contained"
                            className="btn-primary btn-sm"
                            disabled={isSearching}
                            onClick={searchData}
                          >
                            {isSearching ? "Searching .." : "Search"}
                          </Button>
                          
{/* {searchapp?.ReportType === "get_etd_reports_by_admin" && (
                          <Button
                            variant="contained"
                            className="btn-primary btn-sm"
                            disabled={isSearching}
                            onClick={adminSearchData}
                          >
                            {isSearching ? "Searching .." : "Admin Search"}
                          </Button>
)} */}


                          <Button
                            variant="contained"
                            className="btn-primary btn-sm"
                            onClick={clearFrom}
                          >
                            Clear
                          </Button>
                        </div>
                        <div className="col-md-4"></div>
                      </div>
                      {errors && (
                        <div className="error-text">
                          {Object.values(errors).map((error, index) => (
                            <p className="error-text" key={index}>
                              {error}
                            </p>
                          ))}
                        </div>
                      )}
                      {noDataMessage && (
                        <p style={{ textAlign: "center", color: "#888", marginTop: "16px" }}>
                          {noDataMessage}
                        </p>
                      )}
                    </div>
                  </div>
                  {application?.PoolList?.length > 0 && (
                    <div className="card2">
                      <div className="card-body">
                        <div className="row">
                          <div className="container">
                            <>
                              <div className="row">
                                <div className="container">
                                  <div className="col-md-12"></div>

                                  {newData?.Username + loading}

                                  {loading ? (
                                    <div style={styles.loadingContainer}>
                                      <img
                                        src={loadingIcon}
                                        alt="Loading..."
                                        style={styles.loadingImage}
                                      />
                                    </div>
                                  ) : (
                                    <>
                                      {application?.PoolList?.length > 0 && (
                                        <ReportTableComponent
                                          userData={application}
                                          reportType={searchapp}
                                        />
                                      )}
                                    </>
                                  )}
                                </div>
                              </div>
                            </>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </>
  );
}

export default DataReportsPayment;
